import { useEffect, useState } from "react";

// Thumbnails, die es nicht gibt. Einmal pro Sitzung gelernt, damit ein erneut
// gemountetes Bild nicht wieder in denselben 404 laeuft und sichtbar umspringt.
const failedThumbnails = new Set<string>();

export interface WordPressImageProps {
  src: string;
  alt: string;
  showThumbNail: boolean;
  className?: string;
  width?: string | number;
  height?: string | number;
}

export function WordPressImage(props: WordPressImageProps) {
  const { src, showThumbNail, alt, className, width, height } = props;
  const [largeImageLoaded, setLargeImageLoaded] = useState<boolean>(false);

  const extensionIndex = src.lastIndexOf(".");
  // WooCommerce liefert teils schon eine verkleinerte Datei ("...-1024x1024.png").
  // Haengt man daran noch "-400x400", entsteht eine URL, die es nie gibt:
  // WordPress antwortet mit seiner 404-Seite (rund 120 KB HTML), das Bild bleibt
  // solange leer und springt dann sichtbar auf die grosse Fassung um. Eine
  // vorhandene Groessenangabe muss also erst weg.
  const baseSrc = src.slice(0, extensionIndex).replace(/-\d+x\d+$/, "");
  const thumbnailSrc = `${baseSrc}-400x400${src.slice(extensionIndex)}`;

  const preferredSrc = failedThumbnails.has(thumbnailSrc) ? src : thumbnailSrc;

  const [actualSrc, setActualSrc] = useState<string>(preferredSrc);

  useEffect(() => {
    setLargeImageLoaded(false);
    setActualSrc(preferredSrc);
  }, [preferredSrc]);

  const fallBackToOriginal = () => {
    if (actualSrc !== src) {
      failedThumbnails.add(actualSrc);
      setActualSrc(src);
    }
  };

  if (showThumbNail === false) {
    return (
      <div className={`${className ? className : ""} relative`}>
        <img
          src={actualSrc}
          alt={alt}
          onError={fallBackToOriginal}
          className="w-screen top-0 left-0"
          width={width}
          height={height}
        />
        <img
          src={src}
          alt={alt}
          className={`absolute top-0 left-0 ${largeImageLoaded ? "" : "hidden"}`}
          width={width}
          height={height}
          onLoad={() => setLargeImageLoaded(true)}
        />
      </div>
    );
  }

  return (
    <img
      src={actualSrc}
      alt={alt}
      onError={fallBackToOriginal}
      className={className}
      width={width}
      height={height}
    />
  );
}
